import { computed } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestorePromptRoomStateType,
} from '../firestore/PromptRoomStateType'
import type { FirebaseRepository } from './FirebaseRepository'

export class PromptRoomStateType extends ObservableModelWithDecorators<FirestorePromptRoomStateType> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestorePromptRoomStateType>
  ) {
    super(repository, doc)
  }

  @computed
  get title() {
    if (!this.hasData) return ''
    if (this.data.title) return this.data.title

    const id = this.id
    // turn the id into a title i.e blind_spot -> Blind Spot
    return id
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }
}
